export const ITEM_TYPES = {
  DIRECT: 'direktni',
  INDIRECT: 'indirektni',
  VTR: 'vtr',
}; 